import { PlanoPolicy } from "./PlanoPolicy";

export const planoPolicy = new PlanoPolicy()